/**
 * Ruta que el usuario intentaba ver cuando perdió la sesión, para devolverlo
 * ahí después de volver a iniciar sesión.
 *
 * Vive en sessionStorage y no en localStorage porque clearAuthData() vacía el
 * localStorage (ver clearLocalStorageKeepingPersistent) justo en el momento en
 * que se detecta el 401, y porque el destino pendiente pertenece a la pestaña,
 * no al navegador entero.
 */
const RETURN_URL_KEY = 'aria_return_url';

/** Destino cuando no hay ruta pendiente. */
export const DEFAULT_AUTHENTICATED_ROUTE = '/';

/**
 * Solo rutas internas: descarta URLs absolutas o protocol-relative (//host)
 * para no convertir el login en un redirect abierto, y las propias de /auth.
 */
function isSafeInternalUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/auth');
}

/**
 * Guarda la ruta pendiente. El primer origen gana: un 401 suele disparar varias
 * peticiones en paralelo y las siguientes ya leerían la URL del login.
 */
export function saveReturnUrl(url: string | null | undefined): void {
  if (!url || !isSafeInternalUrl(url) || sessionStorage.getItem(RETURN_URL_KEY)) {
    return;
  }
  sessionStorage.setItem(RETURN_URL_KEY, url);
}

/** Devuelve la ruta pendiente y la descarta. */
export function consumeReturnUrl(): string | null {
  const url = sessionStorage.getItem(RETURN_URL_KEY);
  sessionStorage.removeItem(RETURN_URL_KEY);
  return url && isSafeInternalUrl(url) ? url : null;
}

export function clearReturnUrl(): void {
  sessionStorage.removeItem(RETURN_URL_KEY);
}
